import store from '@/store/'
import { USER_CARDS_TYPE } from '@/constants/userCardsType'
import { COMPANIES_WITH_SPECIFIC_FEATURES, TRANSACTION_TYPE_CODES } from '@/modules/transactions/_constants/constants'

export const expenses = [
  {
    path: '/expenses',
    name: 'expenses',
    component: () =>
      import(
        /* webpackChunkName: 'my-expenses' */ '@/modules/transactions/_views/expenses/Index'
      ),
    redirect: to => {
      if (store.getters['UsersStore/userLogged'].userCardsType === USER_CARDS_TYPE.USER_CARDS_WITHOUT) {
        return { name: 'my_pending_reimbursements' }
      }
      return { name: 'my_charged_transactions' }
    },
    meta: {
      section: 'expenses',
      allowedRoles: [
        'ROLE_SUPER_ADMIN',
        'ROLE_COMMERCIAL',
        'ROLE_ADMIN',
        'ROLE_ADMIN_OWNER',
        'ROLE_ACCOUNT_HOLDER',
        'ROLE_REGULAR',
        'ROLE_BOOKKEEPER',
        'ROLE_SUPER_BOOKKEEPER'
      ]
    },
    children: [
      {
        name: 'my_pending_reimbursements',
        path: 'reimbursements/pending',
        component: () =>
          import(
            /* webpackChunkName: 'my-reimbursements-pending' */ '@/modules/transactions/_views/reimbursements/pending/ReimbursementsPending'
          ),
        props: true,
        meta: {
          subpage: 'reimbursements',
          section: 'my_reimbursements',
          breadcrumb: 'my_reimbursements',
          quickFilterSection: 'my_pending_reimbursements',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_BOOKKEEPER'
          ]

        }
      },
      {
        name: 'my_history_reimbursements',
        path: 'reimbursements/history',
        props: true,
        component: () =>
          import(
            /* webpackChunkName: 'my-reimbursements-history' */ '@/modules/transactions/_views/reimbursements/history/ReimbursementsHistory'
          ),
        meta: {
          subpage: 'reimbursements',
          section: 'my_reimbursements',
          breadcrumb: 'my_reimbursements',
          quickFilterSection: 'my_history_reimbursements',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_BOOKKEEPER'
          ]
        }
      },

      {
        name: 'my_charged_transactions',
        path: 'transactions/charged',
        props: true,
        component: () =>
          import(
            /* webpackChunkName: 'charged-transactions' */ '@/modules/transactions/_views/charged/TransactionsChargedIndex'
          ),
        meta: {
          subpage: 'transactions',
          breadcrumb: 'my_transactions',
          section: 'my_transactions',
          quickFilterSection: 'my_charged_transactions',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_BOOKKEEPER'
          ]
        }
      },
      {
        name: 'my_authorizations_transactions',
        path: 'transactions/authorizations',
        props: true,
        component: () =>
          import(
            /* webpackChunkName: 'authorization-transactions' */ '@/modules/transactions/_views/authorizations/TransactionsAuthorizationsIndex'
          ),
        meta: {
          subpage: 'transactions',
          breadcrumb: 'my_transactions',
          section: 'my_transactions',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_BOOKKEEPER'
          ]
        }
      },
      {
        name: 'my_declined_transactions',
        path: 'transactions/declined',
        props: true,
        component: () =>
          import(
            /* webpackChunkName: 'declined-transactions' */ '@/modules/transactions/_views/declined/TransactionsDeclinedIndex'
          ),
        meta: {
          subpage: 'transactions',
          breadcrumb: 'my_transactions',
          section: 'my_transactions',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_BOOKKEEPER'
          ]
        }
      }
    ]
  }
]

export const detailTransactions = [
  {
    path: '/detail-transactions/:transactionId',
    name: 'detailTransactions',
    component: () =>
      import(
        /* webpackChunkName: 'transactions' */ '@/modules/transactions/_views/Index'
      ),
    async beforeEnter (to, from, next) {
      const { params } = to
      store.dispatch('TransactionsStore/clearCurrentTransaction')
      await store.dispatch(
        'TransactionsStore/fetchTransaction',
        params.transactionId
      ).then(async () => {
        const transaction = store.getters['TransactionsStore/currentTransaction']
        if (transaction.type.code === TRANSACTION_TYPE_CODES.EXPENSE) {
          next({
            path: '/reimbursements/pending',
            query: {
              open: transaction.id
            }
          })
        } else {
          next(
            {
              path: '/transactions/charged',
              query: {
                open: transaction.id
              }
            }
          )
        }
      }).catch(() => next())
    },
    meta: {
      section: 'detailTransactions',
      alternateNameLabel: 'section_title_transactions_alternate_label',
      allowedRoles: [
        'ROLE_SUPER_ADMIN',
        'ROLE_COMMERCIAL',
        'ROLE_ADMIN',
        'ROLE_ADMIN_OWNER',
        'ROLE_ACCOUNT_HOLDER',
        'ROLE_REGULAR',
        'ROLE_BOOKKEEPER',
        'ROLE_SUPER_BOOKKEEPER'
      ]
    }
  },
  {
    path: '/detail-transactions/:transactionId/media/:mediaId',
    name: 'detailTransactionsMedia',
    component: () =>
      import(
        /* webpackChunkName: 'transactions' */ '@/modules/transactions/_views/Index'
      ),
    async beforeEnter (to, from, next) {
      const { params } = to
      store.dispatch('TransactionsStore/clearCurrentTransaction')
      await store.dispatch(
        'TransactionsStore/fetchTransaction',
        params.transactionId
      ).then(async () => {
        const transaction = store.getters['TransactionsStore/currentTransaction']
        if (transaction.type.code === TRANSACTION_TYPE_CODES.EXPENSE) {
          next({
            path: '/reimbursements/pending',
            query: {
              open: transaction.id,
              media: true,
              mediaId: params.mediaId
            }
          })
        } else {
          next(
            {
              path: '/transactions/charged',
              query: {
                open: transaction.id,
                media: true,
                mediaId: params.mediaId
              }
            }
          )
        }
      }).catch(() => next())
    },
    meta: {
      section: 'detailTransactions',
      alternateNameLabel: 'section_title_transactions_alternate_label',
      allowedRoles: [
        'ROLE_SUPER_ADMIN',
        'ROLE_COMMERCIAL',
        'ROLE_ADMIN',
        'ROLE_ADMIN_OWNER',
        'ROLE_ACCOUNT_HOLDER',
        'ROLE_REGULAR',
        'ROLE_BOOKKEEPER',
        'ROLE_SUPER_BOOKKEEPER'
      ]
    }
  }
]

export const transactions = [
  {
    path: '/transactions',
    name: 'transactions',
    redirect: () => {
      return '/transactions/charged'
    },
    component: () =>
      import(
        /* webpackChunkName: 'transactions' */ '@/modules/transactions/_views/Index'
      ),
    meta: {
      section: 'transactions',
      alternateNameLabel: 'section_title_transactions_alternate_label',
      allowedRoles: [
        'ROLE_SUPER_ADMIN',
        'ROLE_COMMERCIAL',
        'ROLE_ADMIN',
        'ROLE_ADMIN_OWNER',
        'ROLE_ACCOUNT_HOLDER',
        'ROLE_REGULAR',
        'ROLE_BOOKKEEPER',
        'ROLE_SUPER_BOOKKEEPER'
      ]
    },
    children: [
      {
        name: 'transactions_charged',
        path: 'charged',
        meta: {
          section: 'transactions',
          alternateNameLabel: 'section_title_transactions_alternate_label',

          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_COMMERCIAL',
            'ROLE_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_REGULAR',
            'ROLE_BOOKKEEPER',
            'ROLE_SUPER_BOOKKEEPER'
          ],
          quickFilterSection: 'transactions'
        },
        component: () =>
          import(
            /* webpackChunkName: 'charged-transactions' */ '@/modules/transactions/_views/charged/TransactionsChargedIndex'
          )
      },
      {
        name: 'transactions_declined',
        path: 'declined',
        meta: {
          section: 'transactions',
          alternateNameLabel: 'section_title_transactions_alternate_label',

          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_COMMERCIAL',
            'ROLE_REGULAR',
            'ROLE_BOOKKEEPER',
            'ROLE_SUPER_BOOKKEEPER'
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'declined-transactions' */ '@/modules/transactions/_views/declined/TransactionsDeclinedIndex'
          )
      },
      {
        name: 'transactions_authorizations',
        path: 'authorizations',
        meta: {
          section: 'transactions',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_COMMERCIAL',
            'ROLE_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_REGULAR',
            'ROLE_BOOKKEEPER',
            'ROLE_SUPER_BOOKKEEPER'
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'authorization-transactions' */ '@/modules/transactions/_views/authorizations/TransactionsAuthorizationsIndex'
          )
      }
    ]
  }
]

export const reimbursements = [
  {
    path: '/reimbursements',
    name: 'reimbursements',
    component: () =>
      import(
        /* webpackChunkName: 'reimbursements-index' */ '@/modules/transactions/_views/reimbursements/Index'
      ),
    redirect: () => {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'PLEXUS')
      if (store.getters['CompanyStore/currentCompany'].id === id) {
        return '/reimbursements/pending/users'
      }
      return '/reimbursements/pending'
    },
    meta: {
      section: 'reimbursements',
      alternateNameLabel: 'section_title_reimbursements_alternate_label',
      allowedRoles: [
        'ROLE_SUPER_ADMIN',
        'ROLE_ADMIN',
        'ROLE_REGULAR',
        'ROLE_ADMIN_OWNER',
        'ROLE_ACCOUNT_HOLDER',
        'ROLE_BOOKKEEPER',
        'ROLE_SUPER_BOOKKEEPER'
      ]
    },

    children: [
      {
        name: 'reimbursements_pending_users',
        path: 'pending/users',
        component: () =>
          import(
            /* webpackChunkName: 'reimbursements-pending' */ '@/modules/transactions/_views/reimbursements/pending/ReimbursementsPendingUsers'
          ),
        meta: {
          users: true,
          section: 'reimbursements',
          alternateNameLabel: 'section_title_reimbursements_alternate_label',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_BOOKKEEPER',
            'ROLE_SUPER_BOOKKEEPER'
          ]
        }
      },
      {
        name: 'reimbursements_pending_user_id',
        path: 'pending/users/:userId',
        component: () =>
          import(
            /* webpackChunkName: 'reimbursements-pending' */ '@/modules/transactions/_views/reimbursements/pending/ReimbursementsPending'
          ),
        meta: {
          viewGroup: true,
          breadcrumb: 'reimbursements',
          section: 'reimbursements',
          alternateNameLabel: 'section_title_reimbursements_alternate_label',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_BOOKKEEPER',
            'ROLE_SUPER_BOOKKEEPER'
          ]
        }
      },
      {
        name: 'reimbursements_pending',
        path: 'pending',
        component: () =>
          import(
            /* webpackChunkName: 'reimbursements-pending' */ '@/modules/transactions/_views/reimbursements/pending/ReimbursementsPending'
          ),
        meta: {
          viewGroup: true,
          section: 'reimbursements',
          alternateNameLabel: 'section_title_reimbursements_alternate_label',
          quickFilterSection: 'reimbursements_pending',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_BOOKKEEPER',
            'ROLE_SUPER_BOOKKEEPER'
          ]
        }
      },
      {
        name: 'reimbursements_history_users',
        path: 'history/users',
        component: () =>
          import(
            /* webpackChunkName: 'reimbursements-history' */ '@/modules/transactions/_views/reimbursements/history/ReimbursementsHistoryUsers'
          ),
        meta: {
          users: true,
          section: 'reimbursements',
          alternateNameLabel: 'section_title_reimbursements_alternate_label',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_BOOKKEEPER',
            'ROLE_SUPER_BOOKKEEPER'
          ]
        }
      },
      {
        name: 'reimbursements_history_user_id',
        path: 'history/users/:userId',
        component: () =>
          import(
            /* webpackChunkName: 'reimbursements-history' */ '@/modules/transactions/_views/reimbursements/history/ReimbursementsHistory'
          ),
        meta: {
          viewGroup: true,
          breadcrumb: 'reimbursements',
          section: 'reimbursements',
          alternateNameLabel: 'section_title_reimbursements_alternate_label',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_BOOKKEEPER',
            'ROLE_SUPER_BOOKKEEPER'
          ]
        }
      },
      {
        name: 'reimbursements_history',
        path: 'history',

        component: () =>
          import(
            /* webpackChunkName: 'reimbursements-pending' */ '@/modules/transactions/_views/reimbursements/history/ReimbursementsHistory'
          ),
        meta: {
          viewGroup: true,
          section: 'reimbursements',
          alternateNameLabel: 'section_title_reimbursements_alternate_label',
          quickFilterSection: 'reimbursements_history',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_BOOKKEEPER',
            'ROLE_SUPER_BOOKKEEPER'
          ]
        }
      }
    ]
  }
]
